import { SagaIterator } from 'redux-saga'
import { fork, put, takeEvery, call } from 'redux-saga/effects'
import { DataAction } from '../../actions/commons'
import {
  BILLING_GUIDE_FETCH_PRICING,
  fetchPricingSuccess,
  fetchPricingFail,
} from '../../actions/BillingGuideActions/billingGuideActions'
import { get, ResponseStatus, ResponseWithStatus } from '../../fetch'
import { PricingData } from '../../domain/models/pages/BillingGuideLookupPage/BillingGuideLookupModel'
import text from '../../_constants/text'

const ELASTIC_URL = process.env.REACT_APP_IMED_WEBSITE_ELASTIC_URL

// Type for the raw API response
type PricingResponse = {
  total: number
  results: PricingData[]
}

export function* fetchPricingSaga(action: DataAction<{ clinicName: string; procedureName: string }>): SagaIterator {
  try {
    const params = {
      index: 'i-med-pricing',
      mode: 'pricing',
      clinicName: action.data.clinicName,
      procedureName: action.data.procedureName,
    }

    const response = (yield call(get<PricingResponse>, ELASTIC_URL, {}, params)) as ResponseWithStatus<PricingResponse>

    if (response.status !== ResponseStatus.SUCCESS) {
      console.warn('API error while fetching billing guide pricing data:', response.status)
      yield put(fetchPricingFail(text.BILLING_GUIDE_ERROR_MESSAGE))
      return
    }

    const pricingData: PricingData[] =
      response.data.results?.map((item) => ({
        id: item.id,
        clinicName: item.clinicName,
        modalityName: item.modalityName,
        subModalityName: item.subModalityName,
        privateGap: item.privateGap,
        pensionerGap: item.pensionerGap,
        metadata: { processedAt: item.metadata?.processedAt },
        score: item.score,
      })) || []

    yield put(fetchPricingSuccess(pricingData))
  } catch (error) {
    console.error('Unexpected error while fetching billing guide pricing data:', error)
    yield put(fetchPricingFail(text.BILLING_GUIDE_UNEXPECTED_ERROR_MESSAGE))
  }
}

function* watchFetchPricing(): SagaIterator {
  yield takeEvery(BILLING_GUIDE_FETCH_PRICING, fetchPricingSaga)
}

const pricingSaga = [fork(watchFetchPricing)]

export default pricingSaga
